import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src", "alt"]


interface SrcLsit {
  href: string
  img: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    srcList: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.srcList, (item, index) => {
      return (_openBlock(), _createElementBlock("a", {
        key: index,
        href: item.href,
        class: _normalizeClass([index !== __props.srcList.length - 1 ? 'mr-3' : '', "w-4 h-4 transition-opacity duration-300 cursor-pointer hover:opacity-100"]),
        target: "_blank"
      }, [
        _createElementVNode("img", {
          src: require(`@/images/${ item.img }`),
          alt: item.img
        }, null, 8, _hoisted_3)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})